var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.$route.path.includes('-helpdesk'))?_c('helpdesk'):(_vm.$route.path.includes('-download'))?_c('download'):(_vm.$route.path.includes('-tutorial'))?_c('tutorial'):(_vm.$route.path.includes('-articles'))?_c('articles'):_c('blog')
}
var staticRenderFns = []

export { render, staticRenderFns }